import MainFloatingButton from '../../MainFloatingButton/MainFloatingButton.jsx';
import { tracking } from '../../../utils/tracking';
import { withRouter } from 'react-router';
import React from 'react';

const AIDrillEntryButton = ({ history, intl /** @type {any} */ }) => {
    return (
        <MainFloatingButton
            title={intl.formatMessage({ id: 'linker-ai-drill-entry-button' })}
            icon={
                <img
                    src="/img/icons/ai.svg"
                    alt="linker-ai-drill"
                    width="25"
                    height="25"
                    style={{ verticalAlign: "unset" }}
                />
            }
            onClick={() => {
                tracking('Linker AI Drill Entry Button Clicked', {
                    'Label': intl.formatMessage({ id: 'linker-ai-drill-entry-button' })
                });
                history?.push('/new/media-analysis');
            }}
            isHot={true}
            hotLabelText={intl.formatMessage({ id: 'hot' })}
            ButtonProps={{
                style: {
                    height: '64px',
                    background: '#E5EEFF',
                    borderRadius: '8px',
                    border: '1px solid #345CEB',
                }
            }}
        />
    );
};

export default withRouter(AIDrillEntryButton);